import React, { useState, useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import "./About.css";
import aboutImg from "../../assets/about.jpeg";

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 }); 
  }, []);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-text" data-aos="fade-right">
          <h2>About Us</h2>
          <p>
          Vijay Software Solutions Private Limited

Founded in 2025 by visionary entrepreneur Vijay Bharghav, Vijay Software Solutions Private Limited has swiftly emerged as a dynamic and trusted leader in the global technology landscape. Built on a foundation of innovation, integrity, and customer-centric excellence, the company is dedicated to delivering transformative software products and comprehensive IT solutions that enable businesses to thrive in today’s digital-first world.
          </p>{isExpanded && (
            <p className="more-text" data-aos="fade-up">
            

From its inception, Vijay Software has forged strategic alliances with globally recognized leaders across technology and business domains, enabling the company to stay ahead of industry trends and deliver unmatched service quality. These collaborations have been instrumental in strengthening its expertise in areas such as enterprise software, digital transformation, cloud integration, system architecture, and AI-driven automation.

The company’s strength lies in delivering tailored solutions—ranging from application development and system integration to IT consulting and emerging technology adoption—designed to address the unique needs of every client. Whether supporting startups to scale efficiently or empowering large enterprises to optimize operations, Vijay Software follows a collaborative and agile approach, ensuring every solution is scalable, reliable, and cost-effective.

Driven by a highly skilled team with cross-functional expertise, Vijay Software is dedicated to achieving measurable outcomes and creating long-term value. With rigorous quality assurance practices, transparent communication, and a client-first mindset, the company ensures every project aligns seamlessly with business objectives.

Looking ahead, Vijay Software continues to invest in next-generation technologies such as blockchain, machine learning, IoT, and cybersecurity, positioning itself at the forefront of innovation. With a clear mission to deliver meaningful impact through technology, Vijay Software Solutions Private Limited is shaping the digital present while building the foundations of tomorrow—transforming ideas into world-class digital experiences and nurturing trusted partnerships worldwide.
            </p>
          )}
          <button onClick={toggleReadMore}>
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        </div>
        <div className="about-image" data-aos="fade-left">
          <img src={aboutImg} alt="About Us" />
        </div>
      </div>
    </section>
  );
};

export default About;
